import { Form as AriaForm, type FormProps as AriaFormProps } from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { tv } from "tailwind-variants";

const formStyles = tv({
  base: "flex flex-col gap-4",
});

export interface FormProps extends AriaFormProps {
  children: React.ReactNode;
}

export function Form({ className, ...props }: FormProps) {
  return <AriaForm className={twMerge(formStyles(), className as string)} {...props} />;
}
